import { StyledInvoiceFooter } from "../index.styled";
import ManualTransactions from "./ManualTransactions";
import InvoiceNotes from "./InvoiceNotes";
import { Invoice } from "@lib/types/Billing";
import { Tabs } from "antd";
import { useIntl } from "react-intl";
import { CgNotes } from "react-icons/cg";
import { FaCoins } from "react-icons/fa";

type Props = {
  invoice: Invoice;
  invoiceQueryKey: string[];
  openTab?: string;
};

export default function InvoiceFooter(props: Props) {
  const { invoice, invoiceQueryKey, openTab } = props;
  const { messages } = useIntl();

  return (
    <StyledInvoiceFooter id="invoice-footer">
      <Tabs
        defaultActiveKey={openTab || "1"}
        items={[
          {
            key: "1",
            label: messages["common.notes"] as string,
            children: <InvoiceNotes invoice={invoice} />,
            icon: <CgNotes />,
          },
          {
            key: "2",
            label: messages["common.cashPayments"] as string,
            children: (
              <ManualTransactions
                invoice={invoice}
                invoiceQueryKey={invoiceQueryKey}
              />
            ),
            icon: <FaCoins />,
          },
        ]}
      />
    </StyledInvoiceFooter>
  );
}
